import axiosClient from 'config/axiosClient';

const _url = '/Api/Rooms';
const roomService = {
    getAll: () => {
        return axiosClient.post(_url + '/GetAll');
    },
    getPaging: (option) => {
        return axiosClient.post(_url + '/GetPaging', option);
    },
    getDetail: (id) => {
        return axiosClient.post(_url + '/Get', { id: id });
    },
    createRoom: (data) => {
        return axiosClient.post(_url + '/Create', data);
    },
    updateRoom: (data) => {
        return axiosClient.post(_url + '/Update', data);
    },
    deleteRoom: (id) => {
        return axiosClient.post(_url + '/Delete', { id: id });
    }
};

export default roomService;
